import { Box, Typography } from "@mui/material";

const RecordsTable = ({ columns, rows, getRowId, onRowDoubleClick, emptyMessage = "No records found" }) => {
  const visibleColumns = columns.filter((column) => !column.hide);
  const templateColumns = visibleColumns
    .map((column) => {
      if (column.field === "Actions") return "64px";
      if (column.flex && column.flex <= 0.45) return "82px";
      if (column.flex && column.flex >= 1.3) return "minmax(180px, 1.4fr)";
      return "minmax(120px, 1fr)";
    })
    .join(" ");

  const renderCell = (column, row) => {
    const value = row[column.field];
    if (column.renderCell) {
      return column.renderCell({ row, value });
    }

    return value || value === 0 ? value : <span className="table-muted">N/A</span>;
  };

  if (!rows || rows.length === 0) {
    return (
      <Box className="records-empty">
        <Typography variant="h5">No data</Typography>
        <Typography variant="body2">{emptyMessage}</Typography>
      </Box>
    );
  }

  return (
    <Box className="records-table-wrap">
      <div className="records-table" style={{ "--records-columns": templateColumns }}>
        <div className="records-head">
          {visibleColumns.map((column) => (
            <div key={column.field} className="records-th">
              {column.headerName}
            </div>
          ))}
        </div>

        <div className="records-body">
          {rows.map((row) => {
            const rowId = getRowId ? getRowId(row) : row.id;

            return (
              <div
                key={rowId}
                className="records-row"
                onDoubleClick={() => onRowDoubleClick && onRowDoubleClick({ row })}
              >
                {visibleColumns.map((column) => (
                  <div key={`${rowId}-${column.field}`} className="records-td" data-label={column.headerName}>
                    {renderCell(column, row)}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </Box>
  );
};

export default RecordsTable;
